<template>
  <section class="sal-card">
    <div class="sal-section-head">
      <h1 class="sal-section-title">Piezas y Defectos</h1>
    </div>

    <!-- ✅ Cantidad en PIEZAS -->
    <SALField
      :model-value="localForm.cantidad"
      id="sal-cantidad"
      label="Cantidad de piezas"
      type="text"
      inputmode="numeric"
      min="0"
      step="1"
      max-digits="4"
      placeholder="0"
      :error="errors.cantidad"
      error-message="Ingresa la cantidad de piezas."
      @update:modelValue="handleCantidadInput"
    />

    <!-- ✅ Multiselector grid de códigos -->
    <div class="sal-field">
      <label class="sal-form-label">
        Defectos encontrados
      </label>
      <p class="sal-codes-helper">
        Toca todos los que apliquen.
        <strong v-if="selectedCount > 0" class="sal-codes-count">
          {{ selectedCount }} seleccionado{{ selectedCount > 1 ? 's' : '' }}
        </strong>
      </p>

      <!-- Grid de botones tocables -->
      <div
        class="sal-codes-grid"
        :class="{ 'is-error': errors.codigoError }"
      >
        <button
          v-for="option in codigosError"
          :key="option.value"
          type="button"
          class="sal-code-tile"
          :class="{ 'is-selected': isCodigoSelected(option) }"
          @click="toggleCodigoError(option)"
        >
          <span class="sal-code-tile-num">{{ option.codigo }}</span>
          <span class="sal-code-tile-label">{{ option.label }}</span>
          <i
            v-if="isCodigoSelected(option)"
            class="bi bi-check-circle-fill sal-code-tile-check"
          ></i>
        </button>
      </div>

      <p v-if="errors.codigoError" class="sal-error-message">
        Selecciona al menos un defecto.
      </p>
    </div>
  </section>
</template>

<script setup>
import { computed } from "vue";
import SALField from "../components/SALField.vue";

const props = defineProps({
  modelValue: {
    type: Object,
    required: true,
  },
  codigosError: {
    type: Array,
    default: () => [],
  },
  errors: {
    type: Object,
    default: () => ({}),
  },
});

const emit = defineEmits(["update:modelValue", "field-change"]);

const localForm = computed({
  get: () => props.modelValue,
  set: (value) => emit("update:modelValue", value),
});

const selectedCount = computed(() => {
  return (localForm.value.codigosError || []).length;
});

function isCodigoSelected(option) {
  return (localForm.value.codigosError || []).some(
    (c) => c.value === option.value
  );
}

function toggleCodigoError(option) {
  const current = [...(localForm.value.codigosError || [])];
  const idx = current.findIndex((c) => c.value === option.value);

  if (idx >= 0) {
    current.splice(idx, 1);
  } else {
    current.push(option);
  }

  localForm.value.codigosError = current;
  notifyFieldChange("codigoError");
}

function notifyFieldChange(field) {
  emit("field-change", { field });
}

function handleCantidadInput(value) {
  localForm.value.cantidad = limitNumericDigits(value);
  notifyFieldChange("cantidad");
}

function limitNumericDigits(value, maxDigits = 4) {
  return String(value ?? "")
    .replace(/\D/g, "")
    .slice(0, maxDigits);
}
</script>
